export default __webpack_public_path__ + "static/media/game_02_wrong.335fc55a.png";